import {VtestingJobService} from '../../services/vtesting-job.service';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {CapabilitiesService} from 'src/app/services/capabilities/capabilities.service';
import {Component, OnDestroy,} from '@angular/core';
import {DatePipe} from '@angular/common';

import {
  ColDef,
  GetDetailRowDataParams,
  ICellRendererParams,
  IDetailCellRendererParams,
  ValueGetterParams,
} from 'ag-grid-community';
import {ICellRendererAngularComp} from 'ag-grid-angular';
import * as moment from 'moment';

import {HeaderTitleService} from 'src/app/services/header/header-title.service';
import {BreadcrumbsService} from 'src/app/services/breadcrumbs/breadcrumbs.service';
import {
  ButtonCellRendererComponent
} from 'src/app/components/custom-cell-renderers/button-cell-renderer/button-cell-renderer.component';
import {NotificationService} from 'src/app/services/notification/notification.service';
import {MyInfoIconComponent} from 'src/app/components/my-info-icon/my-info-icon.component';
import {GetVtestingJobRunJob} from '../../interfaces/VtestingJobRun/getVtestingJobRunJob';
import {GetVTestingJobRunDto} from '@vtp/vtpcfg-client-ts';
import {
  ButtonDetailCellRendererComponent
} from 'src/app/components/custom-cell-renderers/button-detail-cell-renderer/button-detail-cell-renderer.component';
import {ConfigurationService} from '../../../services/configuration/configuration.service';
import {Subscription} from 'rxjs';
import {ModalService} from '../../../services/modal/modal.service';

@Component({
  selector: 'app-job-definition-overview',
  templateUrl: './test-job-overview.component.html',
  styleUrls: ['../../../../styles.css'],
})
export class TestJobOverview implements ICellRendererAngularComp, OnDestroy {
  title = 'vTesting job overview';
  description =
    'A vTesting job describes a testing campaign on different levels. A testing job can either be one-time or recurring. A one-time job is referencing a dedicated version of a system under test (SUT). A recurring job references the SUT itself and is continuously tested for every released version of it.';
  primaryButtonText = 'Start test job';
  secondaryButtonText = 'Edit';
  JobRunReportUrl: any[] = [];
  value: any;
  duration: any;
  testjobId: any;
  testJob: any[] = [];
  startedTime: any[] = [];
  finishedTime: any[] = [];
  myJobRunIdArray: any[] = [];
  index: any = 0;
  foundedIndex: any;
  current_stage: any;
  showJobDefinitionDownloadNotification = false;
  showTestDefinitionDownloadNotification = false;
  text: any;
  formattedDate: any;
  id: any;
  EditMode: boolean = false;
  testdefrunidarray: string[] = [];
  fetchRowData: any;

  packageName: string = '-';
  simulationBundleList: any[] = [];
  co_simulationBundleList: any[] = [];
  packageList: any[] = [];
  packageReleaseList: any[] = [];

  selectedTabId!: string;
  tabSubscription!: Subscription;
  routerSubscription$!: Subscription;
  private gridApi: any;

  modalSubscription: Subscription = this.modalService
    .confirmDiscard()
    .subscribe((discard) => {
      if (discard) {
        this.vtestingJobService.runVTestingJob(this.testJob[0].id);
      }
    });

  constructor(
    protected vtestingJobService: VtestingJobService,
    private activedRoute: ActivatedRoute,
    private capabilityservice: CapabilitiesService,
    private configurationService: ConfigurationService,
    private router: Router,
    public headerService: HeaderTitleService,
    public breadcrumbService: BreadcrumbsService,
    public notificationService: NotificationService,
    public modalService: ModalService,
    private activatedRoute: ActivatedRoute
  ) {
    this.routerSubscription$ = this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        this.init();
      }
    });
  }

  //New refresh Logic VTP-2749 start 
  ngOnInit() {
    this.simulationBundleList = [];
    this.co_simulationBundleList= [];
    this.packageList = [];
    this.packageReleaseList = [];
    setInterval(() => {
      this.refreshStatus();
      //Passing the false flag would prevent page reset to 1 and hinder user interaction
    }, 30000); 
  }
//New refresh Logic VTP-2749 ends

  agInit(params: ICellRendererParams): void {
    this.value = params.data.items.test_definition_runs.status;
    throw new Error('Method not implemented.');
  }

  refresh(): boolean {
    return false;
  }

  public columnDefs: ColDef[] = [
    {
      /*   field: 'started_at', */
      headerName: 'Created Date', // Date field name changed under // VTP-2014 VTPL-3
      cellRenderer: 'agGroupCellRenderer',
      /*      valueFormatter: this.dateFormatter, */
      valueGetter: this.ValueGetter,
      flex: 3
    },
    {
      /*   field: 'started_at', */ // VTP-2014 VTPL-3 Starts
      headerName: 'Started Date',
      cellRenderer: 'agGroupCellRenderer',
      /*      valueFormatter: this.dateFormatter, */
      valueGetter: this.startedValueGetter,
      flex: 3
      // VTP-2014 VTPL-3 ends
    },
    {
      field: 'id',
      /*  wrapText: true, */
      autoHeight: true,
      flex: 4,
      /* rowGroup: true */
      headerName: 'Job run ID',
    },
    {
      field: 'duration',
      flex: 2,
      headerName: 'Duration',
    },

    {
      field: 'status',
      flex: 2,
      cellRenderer: (params: ICellRendererParams) => {
        if (params.value === 'CANCELED') {
          /*   this.onCellClicked(this.getJobRunReport(params)); */
          return `<wb-tag variant="error">${params.value}</wb-tag>

          `;
        } else if (params.value === 'CREATED') {
          return `<wb-tag variant="primary">${params.value}</wb-tag>`;
        } else if (params.value === 'QUEUED') {
          return `<wb-tag variant="tertiary">${params.value}</wb-tag>`;
        } else if (params.value === 'RUNNING') {
          return `<wb-tag variant="warning">${params.value}</wb-tag>`;
        } else if (params.value === 'FINISHED') {
          return `<wb-tag variant="success">${params.value}</wb-tag>`;
        }
        params.value === 'FAILED';
        return `<wb-tag variant="error">${params.value}</wb-tag>
        `;
      },
    },
    {
      field: 'status_reason',
      headerName: 'Status reason',
      wrapText: true,
      autoHeight: true,
      sortable: false,
      flex: 3,
      cellRenderer: (params: ICellRendererParams) => {
        return params.value ? params.value : '-';
      },
    },
    {
      field: 'current_stage',
      flex: 2,
      headerName: 'Current stage',
      cellRenderer: (params: ICellRendererParams) => {
        if (params.value === 0) {
          return '-';
        }
        return `${params.value}`;
      },
    },
    {
      field: '',
      headerName: 'Actions',
      sortable: false,
      filter: false,
      menuTabs: [],
      maxWidth: 100,
      cellRenderer: ButtonCellRendererComponent,
      cellRendererParams: (params: ICellRendererParams) => ({
        cancelCallback: () => this.onCancelClickedEvent(params.data),
        downloadCallBack: () => this.onDownloadClickedEvent(params.data),
        // Pass a callback function to handle delete
      }),
    },
    {
      //New refresh Logic VTP-2749 start 
      field: 'report_status',
      flex: 2,
      headerName: 'Report Status',
      cellRenderer: (params: ICellRendererParams) => {
        if (params.value.startsWith('Log')) {
          return `<wb-tag variant="error">${params.value}</wb-tag>`;
        }else if (params.value.startsWith('Report')) {
          return `<wb-tag variant="success">${params.value}</wb-tag>`;
        }else{
          return `<wb-tag variant="">${params.value}</wb-tag>`;
        }
      },
    }
    //New refresh Logic VTP-2749 end
  ];

  ValueGetter(params: ValueGetterParams) {
    return moment(params.data.created_at)
      .utc(false)
      .format('YYYY-MM-DD HH:mm:ss' + ' ' + 'UTC');
  }

  // VTP-2014 VTPL-3 Starts
  startedValueGetter(params: ValueGetterParams) {
    return params.data ? moment(params.data.started_at)
      .year() != 1 ?
      moment(params.data.started_at).utc(false)
     .format('YYYY-MM-DD HH:mm:ss' + ' ' + 'UTC') :'-': '-';
  }
  // VTP-2014 VTPL-3 ends

  public defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    resizable: true,
  };

  onGridReady(gridapi: any) {
    this.gridApi = gridapi;
  }

//New refresh Logic VTP-2749 start 
  refreshStatus(): void {
    let refreshData = false;
    if (this.fetchRowData) {
      for (let index = 0; index < this.rowData.length; index++) {
        const element = this.rowData[index];
        if (element.report_status == 'processing') {
          refreshData = true;
        }
        if(element.test_definition_runs.length > 0){  
          for (let index = 0; index < element.test_definition_runs.length; index++) {
             const element1 = element.test_definition_runs[index];
            if (element1.report_status == 'processing') {
              refreshData = true;
              break;
            }
          }
        }
        if (refreshData) {
          break
        }
      }
    }
    if (refreshData) {
      this.refreshGridData();
      //Passing the false flag would prevent page reset to 1 and hinder user interaction
    }
  }
  //New refresh Logic VTP-2749 ends

  refreshGridData(): void {
    const expandedRowIds: any[] = [];
    //Store the IDs of the expanded rows
    this.gridApi.forEachNode((node: any) => {
      if (node.expanded) {
        expandedRowIds.push(node.id);
      }
    });
    //fetch data
    this.fetchData(expandedRowIds);
    /*  this.gridApi.setRowData(this.fetchRowData); */
  }

  fetchData(expandedRowIds: any[]): any {
    this.testjobId = this.activedRoute.snapshot.paramMap.get('id');
    this.configurationService.getAllJobRuns(this.testjobId).subscribe({
      next: (element: any) => {
        //Fetch & Set New Data

        this.fetchRowData = element.data.items;
        //New refresh Logic VTP-2749 start 
        
        element.data.items.forEach((item: any) => {
          if (item.status === 'FAILED') {
            if (item.report_status === 'processing') {
              item.report_status = 'Logs collection in progress';
            }else if (item.report_status === 'done') {
              item.report_status = 'Logs ready';
            }
          }else{
            if (item.report_status === 'processing') {
              item.report_status = 'Report Collection in Progress';
              
            }else if (item.report_status  === 'done') {
              item.report_status = 'Report ready';
              
            }
          }
          item.test_definition_runs.forEach((newItem: any) => {
            if (newItem.status === 'FAILED') {
              if (newItem.report_status === 'processing') {
                newItem.report_status = 'Logs collection in progress';
              }else if (newItem.report_status === 'done') {
                newItem.report_status = 'Logs ready';
              }
            }else{
              if (newItem.report_status === 'processing') {
                newItem.report_status = 'Report Collection in Progress';
                
              }else if (newItem.report_status  === 'done') {
                newItem.report_status = 'Report ready';
                
              }
            }
            this.startedTime.push(newItem.started_at);
            this.finishedTime.push(newItem.finished_at);
          });
        });
        //New refresh Logic VTP-2749 end 
        return this.fetchRowData;
      },

      error: (error: any) => {
        this.notificationService.handleError(error);
      },
      complete: () => {
        /*         return this.fetchRowData; */
        this.rowData = this.fetchRowData; //New refresh Logic VTP-2749
        //Restore expanded rows
        this.gridApi.setRowData(this.fetchRowData);
        setTimeout(() => {
          this.gridApi.forEachNode((node: any) => {
            if (expandedRowIds.includes(node.id)) {
              node.setExpanded(true);
            }
          });
        }, 0);
      },
    });
  }

  refreshRowsData(): void {
    // Ensure API is available
    if (!this.gridApi) {
    } else {
      this.refreshGridData();
    }
  }

  CancelJobRun(vtesting_job_id: any, vtesting_job_run_id: any): void {
    this.configurationService
      .cancelCurrentRunningVTestingJobRun(vtesting_job_id, vtesting_job_run_id)
      .subscribe({
        next: (response: any) => {
          this.notificationService.notifySuccess = true;
          this.notificationService.notificationSuccesMessage = response.message;
        },
        error: (error: any) => {
          this.notificationService.handleError(error);
        },
      });
    this.notificationService.notifySuccess = false;
  }

  onCancelClickedEvent(data: any): void {
    this.CancelJobRun(data.vtesting_job_id, data.id);
    setTimeout(() => this.refreshRowsData(), 500);
  }

  onDownloadClickedEvent(data: any): void {
    this.getJobRunReport(this.testjobId, data.id);
    setTimeout(() => this.refreshRowsData(), 30000); //New refresh Logic VTP-2749 time changed
  }

  onDownloadTestDefinitionClickedEvent(data: any): void {
    this.getTestDefRunReport(this.testjobId, data.id);
    setTimeout(() => this.refreshRowsData(), 30000); //New refresh Logic VTP-2749 time changed
  }

  public detailCellRendererParams: any = {
    refreshStrategy: 'everything',

    detailGridOptions: {
      rowSelection: 'multiple',
      enableCellChangeFlash: true,

      columnDefs: [
        {
          field: 'name',
          headerName: 'Test definition name',
          flex: 2
        },
        { //VTP-2013 VTPL-5 starts
          field: 'test_object.package_release_id',
          headerName: 'Package Release Info',
          flex: 2,
          cellRenderer: (params: ICellRendererParams) => {
            return params.value ? `<wb-link variant="standalone" href = '${this.showPackageRelease(params.value)}'>${params.value}</wb-link>` : '-';
          }
          //VTP-2013 VTPL-5 ends
        },
        {
          field: 'duration',
          headerName: 'Test definition duration',
          flex: 1,
        },
        {
          field: 'status',
          flex: 2,

          cellRenderer: (params: ICellRendererParams) => {
            if (params.value === 'CANCELED') {
              return `<wb-tag variant="error">${params.value}</wb-tag>

              `;
            } else if (params.value === 'CREATED') {
              return `<wb-tag variant="primary">${params.value}</wb-tag>`;
            } else if (params.value === 'QUEUED') {
              return `<wb-tag variant="tertiary">${params.value}</wb-tag>`;
            } else if (params.value === 'RUNNING') {
              return `<wb-tag variant="warning">${params.value}</wb-tag>`;
            } else if (params.value === 'FINISHED') {
              return `<wb-tag variant="success"

              >${params.value}</wb-tag>`;
            } else if (params.value === 'INTEGRATION') {
              return `<wb-tag variant="warning">${params.value}</wb-tag>`;
            } else if (params.value === 'WAITING_FOR_LICENSE') {
              return `<wb-tag variant="tertiary">WAITING FOR LICENSE</wb-tag>`;
            }

            params.value === 'FAILED';
            return `<wb-tag variant="error">${params.value}</wb-tag>`;
          },
        },

        {
          field: 'status_reason',
          headerName: 'Status reason',
          sortable: false,
          wrapText: true,
          autoHeight: true,
          flex: 4,
          cellRenderer: (params: ICellRendererParams) => {
            return params.value ? params.value : '-';
          },
        },
        {
          field: 'info',
          headerName: 'Information',
          sortable: false,
          cellRenderer: MyInfoIconComponent,
          flex: 2
        },
        {
          field: 'test_orchestration.execution_order',
          headerName: 'Stage',
          wrapText: true,
          autoHeight: true,
          flex: 1,
          cellRenderer: (params: ICellRendererParams) => {
            return params.value ? params.value : '-';
          },
        },
        {
          field: 'status',
          headerName: 'Action',
          flex: 1,
          cellRenderer: ButtonDetailCellRendererComponent,
          cellRendererParams: (params: ICellRendererParams) => ({
            /*          cancelCallback: () => this.onCancelClickedEvent(params.data), */
            downloadCallBack: () =>
              this.onDownloadTestDefinitionClickedEvent(params.data),
          }),
        },
        {
          //New refresh Logic VTP-2749 starts
          field: 'report_status',
          flex: 2,
          headerName: 'Report Status',

          cellRenderer: (params: ICellRendererParams) => {
            if (params.value.startsWith('Log')) {
              return `<wb-tag variant="error">${params.value}</wb-tag>`;
            }else if (params.value.startsWith('Report')) {
              return `<wb-tag variant="success">${params.value}</wb-tag>`;
            }else{
              return `<wb-tag variant="">${params.value}</wb-tag>`;
            }
          },
        }
        //New refresh Logic VTP-2749 ends
      ],
      domLayout: 'autoHeight',
      defaultColDef: {
        resizable: true,
      },
    },
    getDetailRowData: (params: GetDetailRowDataParams) => {
      params.successCallback(params.data.test_definition_runs);
    },
  } as IDetailCellRendererParams<GetVTestingJobRunDto, GetVtestingJobRunJob>;

  public rowData!: GetVTestingJobRunDto[];

  fetchGridData() {
    this.configurationService.getAllJobRuns(this.testjobId).subscribe({
      next: (element: any) => {
        this.rowData = element.data.items;
        element.data.items.forEach((item: any) => {
          if (item.status === 'FAILED') {
            if (item.report_status === 'processing') {
              item.report_status = 'Logs collection in progress';
            }else if (item.report_status === 'done') {
              item.report_status = 'Logs ready';
            }
          }else{
            if (item.report_status === 'processing') {
              item.report_status = 'Report Collection in Progress';
              
            }else if (item.report_status  === 'done') {
              item.report_status = 'Report ready';
              
            }
          }
          item.test_definition_runs.forEach((newItem: any) => {
            if (newItem.status === 'FAILED') {
              if (newItem.report_status === 'processing') {
                newItem.report_status = 'Logs collection in progress';
              }else if (newItem.report_status === 'done') {
                newItem.report_status = 'Logs ready';
              }
            }else{
              if (newItem.report_status === 'processing') {
                newItem.report_status = 'Report Collection in Progress';
                
              }else if (newItem.report_status  === 'done') {
                newItem.report_status = 'Report ready';
                
              }
            }
            this.startedTime.push(newItem.started_at);
            this.finishedTime.push(newItem.finished_at);
          });
        });
        this.vtestingJobService.setStartedTime(this.startedTime);
        this.vtestingJobService.setFinishedTime(this.finishedTime);
      },
      error: (error) => {
        this.notificationService.handleError(error);
      },
    });
  }

  manageLoadingSpinner(condition: boolean): void {
    if (condition) {
      this.vtestingJobService.loadingSpinner = true;
      this.headerService.primaryDisabled = true;
      this.headerService.secondaryDisabled = true;
    } else {
      this.vtestingJobService.loadingSpinner = false;
      this.headerService.primaryDisabled = false;
      this.headerService.secondaryDisabled = false;
    }
  }

  init(): void {
    this.headerService.setTabs([
      { label: 'Information', id: 'info' },
      { label: 'Permissions', id: 'permissions' },
    ]);
  
    const queryTab = this.activatedRoute.snapshot.queryParamMap.get('tab');
    if (queryTab) {
      this.headerService.setSelectedTab({ label: '', id: queryTab });
    }
  
    this.tabSubscription = this.headerService.selectedTab$.subscribe((tab) => {
      this.selectedTabId = tab;
      this.breadcrumbService.setBreadcrumbs([
        { label: 'vTesting jobs', route: '/vtesting-jobs' },
        {
          label: this.testJob[0]?.name,
          route: `/vtesting-jobs/vtesting-job/${this.testJob[0]?.id}/overview`,
        },
        {
          label: tab === 'info' ? 'Information' : 'Permissions',
          route: '',
        },
      ]);
    });
  
    this.headerService.pageDescription = this.description;
    this.headerService.pageTitle = this.title;
    this.initHeaderActions();
  
    this.testjobId = this.activedRoute.snapshot.paramMap.get('id');
    this.vtestingJobService.jobId = this.testjobId;
    this.manageLoadingSpinner(true);
    this.configurationService.getVTestingJob(this.testjobId).subscribe({
      next: (element) => {
        this.vtestingJobService.currentJobOverview = element.data;
  
        //Clear lists to prevent duplication on tab switch
        this.packageList = [];
        this.packageReleaseList = [];
        this.simulationBundleList = [];
        this.co_simulationBundleList = [];
  
        for (let index = 0; index < element.data.test_definitions.length; index++) {
          const def = element.data.test_definitions[index];
          const testObj = def.test_object;
  
          if (testObj?.simulation_bundle_id && !this.simulationBundleList.find(sim => sim.id === testObj.simulation_bundle_id)) {
            this.simulationBundleList.push({ id: testObj.simulation_bundle_id, name: def.name });
          }
  
          if (testObj?.co_simulation_bundle_id && !this.co_simulationBundleList.find(sim => sim.id === testObj.co_simulation_bundle_id)) {
            this.co_simulationBundleList.push({ id: testObj.co_simulation_bundle_id, name: def.name });
          }
  
          if (testObj?.package_id) {
            this.capabilityservice.getvPackage(testObj.package_id).subscribe({
              next: (response) => {
                this.packageName = response.data.name;
                if (!this.packageList.find(p => p.id === testObj.package_id && p.testdefid === def.id)) {
                  this.packageList.push({
                    id: testObj.package_id,
                    name: response.data.name,
                    testdefid: def.id,
                    testdefname: def.name,
                  });
                }
              },
              error: (error) => this.notificationService.handleError(error),
            });
          }
  
          if (testObj?.package_release_id) {
            this.packageReleaseList.push({
              id: testObj.package_release_id,
              testdefname: def.name,
            });
          }
        }
  
        this.testJob = [element.data];
        this.headerService.primaryButtonText = element.data.continuous ? '' : this.primaryButtonText;
  
        this.formattedDate = moment(element.data.created_at)
          .utc(false)
          .format('YYYY-MM-DD HH:mm:ss [UTC]');
      },
      complete: () => {
        this.initBreadCrumb();
        this.manageLoadingSpinner(false);
      },
      error: (error) => {
        this.notificationService.handleError(error);
        this.router.navigate(['/vtesting-jobs']);
      },
    });
  
    // Sample duration calculation
    const date_started_at = new Date('2023-12-12T12:03:20.727663+00:00');
    const date_finished_at = new Date('2023-12-12T12:07:55.727663+00:00');
    this.duration = Number(date_finished_at) - Number(date_started_at); 
    this.fetchGridData();
  }

  private initHeaderActions() {
    this.headerService.secondaryButtonText = this.secondaryButtonText;

    setTimeout(() => this.setPrimaryClick(), 500);
    this.headerService.secondaryClick$.subscribe(() => this.editGeneralData());
    this.headerService.tertiaryClick$.subscribe(() => this.backToOverview());
  }

  private initBreadCrumb() {
    let tab = this.activatedRoute.snapshot.queryParamMap.get('tab');

    this.breadcrumbService.setBreadcrumbs([
      {
        label: 'vTesting jobs',
        route: '/vtesting-jobs',
      },
      {
        label: this.testJob[0].name,
        route: `/vtesting-jobs/vtesting-job/${this.testJob[0].id}/overview`,
      }
    ]);

    if (tab) {
      this.breadcrumbService.breadcrumbs.push({
        label: tab == 'info' ? "Information" : "Permissions",
        route: ''
      });
    } else {
      this.breadcrumbService.breadcrumbs.push({
        label: 'Information',
        route: ''
      });
    }
  }

  ngOnDestroy() {
    this.headerService.setTabs([]);
    this.tabSubscription.unsubscribe();
    this.routerSubscription$.unsubscribe();
    this.modalSubscription.unsubscribe();
  }

  setPrimaryClick(): void {
    this.headerService.primaryClick$.subscribe(() => {
      this.startTestJobManually();
      this.refreshRowsData();
    });
  }

  loadData() {
    this.showJobDefinitionDownloadNotification = true;
  }

  loadTestDefData() {
    this.showTestDefinitionDownloadNotification = true;
  }

  getJobRunReport(testjobId: any, testdefrunid: any) {
    this.loadData();

    this.configurationService.getAllJobRuns(testjobId).subscribe({
      next: (element) => {
        element.data.items.forEach((item: any) => {
          this.myJobRunIdArray.push(item.id);
        });
        this.foundedIndex = this.myJobRunIdArray.indexOf(testdefrunid);
        this.myJobRunIdArray = [];
        this.configurationService
          .getJobRunReport(testjobId, element.data.items[this.foundedIndex].id)
          .subscribe({
            next: (Element) => {
              this.JobRunReportUrl = Element.data.url;
              this.onDownload(this.JobRunReportUrl);
              this.showJobDefinitionDownloadNotification = false;
            },
            error: (error) => {
              this.notificationService.handleError(error);
            },
          });
      },
      error: (error) => {
        this.notificationService.handleError(error);
      },
    });
  }

  getTestDefRunReport(vtesting_job_id: any, test_definition_run_id: any) {
    this.loadTestDefData();
    this.configurationService.getAllJobRuns(vtesting_job_id).subscribe({
      next: (element) => {
        element.data.items.forEach((item: any) => {
          this.myJobRunIdArray.push(item.id);
          item.test_definition_runs.forEach((testdefitem: any) => {
            this.testdefrunidarray.push(testdefitem.id);
          });
        });

        element.data.items.forEach((item: any) => {
          item.test_definition_runs.forEach((testdefitem: any) => {
            if (testdefitem.id == test_definition_run_id) {
              this.id = this.myJobRunIdArray.indexOf(item.id);

              return this.id;
            } else if (testdefitem.id != test_definition_run_id) {
              return;
            }
          });
        });

        this.myJobRunIdArray = [];

        this.testdefrunidarray = [];

        this.configurationService
          .getTestDefRunReport(
            vtesting_job_id,
            element.data.items[this.id].id,
            test_definition_run_id
          )
          .subscribe({
            next: (element: any) => {
              let TestDefiRunReportUrl = element.data.url;

              this.onDownload(TestDefiRunReportUrl);
              this.showTestDefinitionDownloadNotification = false;
            },
            error: (error: any) => {
              this.notificationService.handleError(error);
            },
          });
      },
      error: (error) => {
        this.notificationService.handleError(error);
      },
    });
  }

  onDownload(url: any) {
    this.capabilityservice.downLoadFile(
      url,
      moment().format('MM-DD-YYYYThh-mm-ss') +
      '-' +
      this.testJob[0].name +
      '-' +
      this.testJob[0].id
    );
  }

  editGeneralData(): void {
    this.EditMode = true;
    this.vtestingJobService.setEditMode(this.EditMode);
    this.vtestingJobService.setVtestingJobId(this.testjobId);
    this.router.navigate([`vtesting-job/general`]).then(
      () => {
        this.vtestingJobService.setVtestingJobId(this.testjobId);
      },
      (err) => {
        this.notificationService.handleError(err);
      }
    );
  }

  private backToOverview() {
    this.router.navigate([`vtesting-jobs`]);
  }

  startTestJobManually() {
    this.EditMode = false;
    this.vtestingJobService.setEditMode(this.EditMode);
    this.modalService.initializeCustomModal(
      'test-job-manually-run',
      'Start test job manually?',
      'You will start the test job manually. All test definitions will run trough there process.'
    );
    /*  this.refreshRowsData(); */
    /*  this.refreshRowsData(); */
  }

  showPackage(event: string) {
    this.router.navigate(['vpackages/vpackage/' + event + '/overview'])
  }

  showSimulationBundles(event: string) {
    this.router.navigate(['simulation/' + event + '/overview'])
  }

  showCo_SimulationBundles(event: string) {
    this.router.navigate(['co-simulation/' + event + '/overview'])
  }
  //VTP-2013 VTPL-5 starts
  showPackageRelease(params : string){
    return 'vpackage-release/' + params + '/overview';
  }
  //VTP-2013 VTPL-5 ends
}
